(function () {
  if (window.__thrDragSlider) return;
  window.__thrDragSlider = true;

  function items(track) {
    var selector = track.getAttribute('data-thr-drag-item') || ':scope > *';
    try {
      return Array.prototype.slice.call(track.querySelectorAll(selector));
    } catch (err) {
      return Array.prototype.slice.call(track.children);
    }
  }

  function canScroll(track) {
    return track.scrollWidth > track.clientWidth + 4;
  }

  function gapOf(track) {
    var styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap) || 0;
  }

  function slideStep(track) {
    var list = items(track);
    if (!list.length) return Math.max(track.clientWidth * 0.7, 220);
    return list[0].getBoundingClientRect().width + gapOf(track);
  }

  function alignMode(track) {
    var list = items(track);
    if (!list.length) return 'start';
    var snap = window.getComputedStyle(list[0]).scrollSnapAlign || '';
    return snap.indexOf('center') !== -1 ? 'center' : 'start';
  }

  function targetForItem(track, el) {
    var left = el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    if (alignMode(track) === 'center') {
      return left - (track.clientWidth - el.getBoundingClientRect().width) / 2;
    }
    return left;
  }

  function nearestScroll(track, proposed) {
    var list = items(track);
    if (!list.length) return proposed;
    var best = targetForItem(track, list[0]);
    var bestDist = Infinity;
    list.forEach(function (el) {
      var left = targetForItem(track, el);
      var dist = Math.abs(left - proposed);
      if (dist < bestDist) {
        bestDist = dist;
        best = left;
      }
    });
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    return Math.max(0, Math.min(best, max));
  }

  function skipPointer(event) {
    var target = event.target;
    if (!target || !target.closest) return true;
    if (target.closest('input, textarea, select, label')) return true;
    if (target.closest('.thr-video-grid__arrow, .thr-product-tabs__arrow, .thr-members__arrow, .thr-reviews__arrow')) {
      return true;
    }
    var control = target.closest('button, [role="button"]');
    if (!control) return false;
    return !control.classList.contains('deferred-media__poster-button');
  }

  function enhance(track) {
    if (track.dataset.thrDragReady) return;
    track.dataset.thrDragReady = '1';
    track.classList.add('thr-drag-slider');

    var pending = false;
    var dragging = false;
    var dragged = false;
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var lastX = 0;
    var lastT = 0;
    var velocity = 0;
    var snapValue = '';
    var THRESHOLD = 10;

    function beginDrag(event) {
      if (dragging) return;
      dragging = true;
      dragged = true;
      snapValue = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(event.pointerId);
      } catch (err) {}
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      if (skipPointer(event)) return;
      if (!canScroll(track)) return;
      pending = true;
      dragging = false;
      dragged = false;
      pointerId = event.pointerId;
      startX = lastX = event.clientX;
      startScroll = track.scrollLeft;
      lastT = performance.now();
      velocity = 0;
    });

    track.addEventListener('pointermove', function (event) {
      if (!pending || (pointerId != null && event.pointerId !== pointerId)) return;
      var now = performance.now();
      var dx = event.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD) return;
        beginDrag(event);
      }
      var dt = Math.max(now - lastT, 1);
      velocity = (event.clientX - lastX) / dt;
      lastX = event.clientX;
      lastT = now;
      track.scrollLeft = startScroll - dx;
    });

    function finish(event) {
      if (!pending) return;
      if (event && pointerId != null && event.pointerId !== pointerId) return;
      pending = false;
      var didDrag = dragging;
      dragging = false;
      track.classList.remove('is-dragging');
      try {
        if (event && track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      } catch (err) {}
      pointerId = null;

      if (!didDrag) return;

      var flick = -velocity * 220;
      var maxFlick = slideStep(track) * 2;
      if (flick > maxFlick) flick = maxFlick;
      if (flick < -maxFlick) flick = -maxFlick;
      if (Math.abs(flick) < 40) flick = 0;

      var target = nearestScroll(track, track.scrollLeft + flick);
      track.scrollTo({ left: target, behavior: 'smooth' });

      window.setTimeout(function () {
        track.style.scrollSnapType = snapValue;
        track.dispatchEvent(new CustomEvent('thr-drag-settle', { bubbles: true }));
      }, 380);
    }

    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);

    track.addEventListener(
      'click',
      function (event) {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      },
      true
    );
  }

  function scan() {
    document.querySelectorAll('[data-thr-drag-slider]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
